import Choices from 'choices.js';

class Form{
    constructor(){
        this.section = document.querySelector('.section_contact_form') ? document.querySelectorAll('.section_contact_form') : false;
        
        !this.section || this.section.forEach(el => this.s_form(el));
        let elements = document.querySelector('.team__block') ? document.querySelector('.team__block') : '';
        let close = document.querySelector('.team__modal--close') ? document.querySelectorAll('.team__modal--close') : '';
        !elements || elements.forEach(element => {
            element.addEventListener('click', () => {
                elements.forEach(el => el.querySelector('.team__modal').classList.remove('active'));
                element.querySelector('.team__modal').classList.add('active');
            })
        });
    }

    s_form(el){

        
        el.querySelector('.select_norm') ? el.querySelectorAll('.select_norm').forEach(select => new Choices(select, { searchEnabled: false, shouldSort: false, shouldSortItems: false,})) : '';

        el.querySelector('.select_small') ? new Choices(el.querySelector('.select_small'), {
            searchEnabled: false,
            itemSelectText : ''
        }) : '';
    }

}

export default Form;